import { Pipe, PipeTransform } from '@angular/core';
import { SECONDS_IN_HOURS } from '@app/modules/flight-results/mappers/filters.mapper';

@Pipe({
  name: 'flightDuration',
  standalone: false
})
export class FlightDurationPipe implements PipeTransform {

  constructor() { }

  transform(departureDate: string, arrivalDate: string, ...args: string[]): string {
    const seconds = (new Date(arrivalDate).getTime() - new Date(departureDate).getTime()) / 1000;

    const hours = Math.floor(seconds / SECONDS_IN_HOURS);
    const minutes = Math.floor((seconds - (hours * SECONDS_IN_HOURS)) / 60);

    let stringMinutes = `${minutes}`;

    if (minutes < 10) stringMinutes = `0${stringMinutes}`;

    return hours > 0 ? `${hours}h ${stringMinutes}m` : `${stringMinutes}m`;
  }
}
